import "./receipt.css";
import { CurrencyFormatter } from "../../utils/CurrencyFormatter";
import { forwardRef } from "react";
import moment from "moment";
const Receipt = forwardRef(
  ({ items, store, tendered, payment_method, purchaser }, ref) => (
    <div className="receipt-container" ref={ref}>
      <div className="receipt-heading mb20">
        <div className="receipt-heading-left">
          <h1 className="company-name">{store?.name}</h1>
          <h2 className="company-phone">{store?.email}</h2>
          <h2 className="company-phone">{store?.phone}</h2>
          <h2 className="company-phone">{store?.location}</h2>
        </div>

        <img src="/logo.png" alt="store sync logo" className="company-logo" />
      </div>
      <div className="receipt-details">
        {items?.map((item) => (
          <div className="receipt-details-sub-container" key={item?.id}>
            <h1 className="receipt-item-name">{`${item?.item_name} [${item.id}]`}</h1>
            <div className="receipt-sub-data">
              <span>{item?.quantity}x</span>
              <span>{CurrencyFormatter(item?.price)}</span>
              <span>{CurrencyFormatter(item?.cost)}</span>
            </div>
          </div>
        ))}
        <div className="receipt-summary">
          <span className="">Total [{items?.length}]</span>
          <span className="">
            {CurrencyFormatter(items.reduce((a, b) => a + b.cost, 0))}
          </span>
        </div>
        <div className="receipt-summary">
          <span className="">Payment Method </span>
          <span className="">{payment_method}</span>
        </div>
        <div className="receipt-summary">
          <span className="">Tendered </span>
          <span className="">{CurrencyFormatter(tendered)}</span>
        </div>
        <div className="receipt-summary">
          <span className="">Balance</span>
          <span className="">
            {CurrencyFormatter(
              tendered - items.reduce((a, b) => a + b.cost, 0)
            )}
          </span>
        </div>
        <div className="post-summary-data-container">
          <h2 className="post-summary-data">
            Cashier ID:
            {store?.mode === "Admin" ? store?.mode : store?.attendant.id}
          </h2>
          <h2 className="post-summary-data">
            Receipt id: {Math.floor(Math.random() * 99999)}
          </h2>
          <h2 className="post-summary-data">Purchaser: {purchaser}</h2>
          <h2 className="post-summary-data">
            Date: {moment().format("YYYY.MM.DD HH:mm:ss")}
          </h2>
        </div>
      </div>
      <div className="receipt-footer">
        <span>Thanks for stopping by. Come back anytime!</span>
        <span>This shop is managed by: webcrony online' store sync app</span>
        <span>Call us: : +233 (0)55 338 5436</span>
      </div>
    </div>
  )
);

export default Receipt;
